<div class="container" style="padding-left: 0; padding-right: 0;">
  <header class="navbar navbar-light navbar-fixed-top navbar-expand-lg">

    <a class="navbar-brand" routerLink="/home" (click)="navbarCollapsed = true">Mat Progress Buttons</a>

    <button class="navbar-toggler navbar-toggler-right" type="button" (click)="navbarCollapsed = !navbarCollapsed"
            [attr.aria-expanded]="!navbarCollapsed" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse" [ngbCollapse]="navbarCollapsed" id="navbarContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" href="https://github.com/michaeldoye/mat-progress-buttons#installation" (click)="navbarCollapsed = true">Getting Started</a>
        </li>
      </ul>
    </div>
  </header>
</div>